import { c as _c } from "react/compiler-runtime";
import { Loading } from '@netpurpose/np-ui';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import styled from 'styled-components';
import { useReportUrl } from '#hooks';

// Loading fills its parent's height, so give it the full viewport to centre within.
const FullHeightContainer = styled.div`
  height: 100vh;
`;

// The Report page is the app's home. It isn't a fixed route - it resolves to the
// user's most recently viewed portfolio (see useReportUrl), so we resolve it client
// side here and redirect once the underlying data is available.
export const HomeRedirect = () => {
  const $ = _c(6);
  const router = useRouter();
  const {
    reportUrl,
    isLoading
  } = useReportUrl();
  let t0;
  let t1;
  if ($[0] !== isLoading || $[1] !== reportUrl || $[2] !== router) {
    t0 = () => {
      if (!isLoading) {
        router.replace(reportUrl);
      }
    };
    t1 = [isLoading, reportUrl, router];
    $[0] = isLoading;
    $[1] = reportUrl;
    $[2] = router;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FullHeightContainer><Loading /></FullHeightContainer>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};